const locale = {
	HOME:'ホーム',
	MAP:'地図',
	DASHBOARD: 'ダッシュボード',
	ADDMEMBER: 'ユーザー登録・編集',
	ADDPROJECT: '現場',
	MAPPING: '現場ユーザー関連付け',
	RECYCLE: 'リサイクル',
	INITIALIZATION: '初期化',
	MULTIPLE_COMPANIES:'企業',
	DEVICESETTINGS: 'デバイス設定',
	CONNECT: 'コネクト',
	LIVESTREAM: 'ライブストリーム',
	DOWNLOADSTREAM: 'ダウンロードストリーム',
	SWITCH_TO_USER: '管理者モードへ',
	MIX_CALENDAR: 'ミックスカレンダー',
	LIVE_STREAM: 'ライブストリーム',
	DOWNLOAD_STREAM: 'ダウンロードストリーム',
	CONTACT: '連絡先',
	CCTV_MAP: '切羽カメラ地図',
	CCTV: '切羽カメラ',
	SAFETY: 'SAFETY',
	BUILDEE: 'BUILDEE',
	GREEN_SITE: 'GREEN SITE',
	RISK_PREDICTION: 'リスク予測',
	IOT2D: 'IOT(2D)',
	IOT3D: 'IOT(3D)',

};

export default locale;